export class KeyCodes {
    public static readonly ARROW_UP: string = 'ArrowUp';
    public static readonly ARROW_DOWN: string = 'ArrowDown';
    public static readonly ARROW_LEFT: string = 'ArrowLeft';
    public static readonly ARROW_RIGHT: string = 'ArrowRight';
    public static readonly ENTER: string = 'Enter';
    public static readonly TAB: string = 'Tab';
    public static readonly ESCAPE: string = 'Escape';
    public static readonly SPACEBAR: string = 'Space';
}
